import PropTypes from "prop-types";
import React from "react";
import GenericQuizCorrector from "../../GenericQuiz/corrector.js";
import QuestionResult from "../../GenericQuiz/question-result.js";

function Corrector(props) {
  return (
    <GenericQuizCorrector {...props} activityEndpoint="mathcalculations">
      {({ id, left, sign, right, ...questionProps }) => (
        <QuestionResult
          key={id}
          {...questionProps}
          question={left + " " + sign + " " + right + " = "}
        />
      )}
    </GenericQuizCorrector>
  );
}
Corrector.propTypes = {
  milestoneId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  activityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  from: PropTypes.string,
};

export default Corrector;
